import {Component, Input} from '@angular/core';
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {InfoModalComponent} from "../../modals/info-modal/info-modal.component";
import {SignupModalComponent} from "../../modals/signup-modal/signup-modal.component";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {AuthService} from "../../../services/auth/auth.service";

@Component({
  selector: 'app-answers-summary',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    NgClass
  ],
  templateUrl: './answers-summary.component.html',
  styleUrl: './answers-summary.component.scss'
})
export class AnswersSummaryComponent {

  @Input() login?: string | null = null;
  @Input() thresholds?: any;
  @Input() answers?: Array<any>;

  modalRef!: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private authSrv: AuthService
  ) {
  }

  getFirstLine(str: string): string {
    const lines: string[] = str.split('\n');
    if (lines) {
      return lines[0].trim();
    }
    return '';
  }

  print() {
    window.print();
  }

  openModalInfo(threshold: any): void {
    const modalOptions: ModalOptions = {
      class: 'modal-lg modal-dialog-centered',
      initialState: {
        message: this.transformBr(threshold.content),
        title: threshold.questionGroupName
      }
    };
    this.modalRef = this.modalService.show(InfoModalComponent, modalOptions);
  }

  openModalSignup(): void {
    const modalOptions: ModalOptions = {
      class: 'modal-lg modal-dialog-centered',
      initialState: {
        survey: sessionStorage.getItem('survey'),
        endSignup: () => {
          this.modalRef.hide();
          this.showLogin();
        }
      }
    };
    this.modalRef = this.modalService.show(SignupModalComponent, modalOptions);
  }

  transformBr(str: string): string {
    const lines: string[] = str.split('\n');
    lines.shift();

    const response: string = lines.join('\n');

    return response.replace(/\n/g, "<br>");
  }

  showLogin(): void {
    const modalOptions: ModalOptions = {
      class: 'modal-lg modal-dialog-centered',
      initialState: {
        message: 'Il te suffit de retenir ton mot de passe et le login suivant : <span class="fw-bolder text-primary">' + this.authSrv.getLogin() + '</span>.',
        title: 'Ton compte anonyme a bien été créé !'
      }
    };
    this.modalRef = this.modalService.show(InfoModalComponent, modalOptions);
  }
}
